import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import * as styles from './spotlight.css';

export type SpotlightItemProps = ComponentPropsWithoutRef<'div'> & {
  /** Whether this row is the keyboard selection (hover is CSS-only, separate). */
  focused?: boolean;
};

/** A single selectable result row; highlights when `focused`. */
export const SpotlightItem = forwardRef<HTMLDivElement, SpotlightItemProps>(
  ({ children, className, focused = false, ...props }, ref) => (
    <div
      aria-selected={focused}
      className={clsx(styles.item, focused && styles.itemFocused, className)}
      ref={ref}
      role="option"
      {...props}
    >
      {children}
    </div>
  )
);

SpotlightItem.displayName = 'SpotlightItem';
